import { motion, type MotionProps } from 'framer-motion'
import React, { useId } from 'react'

interface AnimatedListProps {
  items?: Array<React.ReactNode>
  footer?: React.FC | React.ReactNode
  itemGap?: string
  whileHover?: MotionProps['whileHover']
  whileTap?: MotionProps['whileTap']
}

const listItemVariants = {
  initial: { opacity: 0, y: -8, height: 0 },
  animate: { opacity: 1, y: 0, height: 'auto' },
  exit: { opacity: 0, y: -8, height: 0 }
}

export const AnimatedList: React.FC<AnimatedListProps> = ({
  items = [],
  footer,
  whileHover,
  whileTap
}) => {
  const uniqueKey = useId()
  const children = React.Children.toArray(items).filter((child): child is React.ReactElement =>
    React.isValidElement(child)
  )
  const footerContent = typeof footer === 'function' ? React.createElement(footer) : footer ?? null

  return (
    <>
      {children.map((child, index) => {
        const childKey =
          typeof child.key === 'string' || typeof child.key === 'number'
            ? child.key
            : `${uniqueKey}-${index}`

        return (
          <motion.div
            layout="position"
            key={childKey}
            variants={listItemVariants}
            initial={false}
            animate="animate"
            exit="exit"
            whileHover={whileHover}
            whileTap={whileTap}
          >
            {child}
          </motion.div>
        )
      })}

      {footerContent && <motion.div layout="position">{footerContent}</motion.div>}
    </>
  )
}
